import { styled } from "@mui/system";
import { Button } from "@totalenergiescode/mobility-business-rev-design-system";

import { MemoizedPageHeader as PageHeader } from "@/components/shared/PageHeader/component";

const PANELS_MARGIN = "40px";

export const StyledContainer = styled("div")`
  font-family: "Roboto", sans-serif;
  display: flex;
  flex-direction: column;
  gap: 10px;
  box-sizing: border-box;
  height: 100%;
  width: 100%;
`;

export const StyledPageHeader = styled(PageHeader)`
  justify-content: space-between;
  padding: 0 40px 20px 40px;
`;

export const StyledPanelsContainer = styled("div")`
  display: grid;
  gap: 10px;
  box-sizing: border-box;
  min-height: 0;
  grid-template-columns: 35% 1fr;
`;

export const StyledTemplateSelectorLabel = styled("div")`
  margin-bottom: 20px;
  font-size: 16px;
  font-weight: 400;
`;

export const StyledTemplateSelectorButtons = styled("div")`
  display: flex;
  justify-content: space-between;
  gap: 10px;
  max-width: 100%;
  flex-wrap: wrap;
  margin-bottom: 20px;
`;

export const StyledTemplateSelector = styled("div")`
  font-size: 16px;
  font-weight: 400;
`;

export const StyledJsonPanel = styled("div")`
  border-radius: 8px;
  max-height: calc(100vh - ${PANELS_MARGIN});
  padding: 20px;
  box-sizing: border-box;
  border: 1px solid ${({ theme }) => theme.palette.divider};
  background: ${({ theme }) => theme.palette.background.paper};
`;

export const StyledRenderPanel = styled("div")`
  height: 100%;
  max-height: calc(100vh - ${PANELS_MARGIN});
  border: 1px solid ${({ theme }) => theme.palette.divider};
  border-radius: 8px;
  padding: 20px;
  box-sizing: border-box;
  background: ${({ theme }) => theme.palette.background.paper};
`;

export const StyledHeader = styled("div")`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const StyledTitle = styled("div")`
  font-size: 20px;
  font-weight: 600;
`;

export const StyledLoadButton = styled(Button)`
  margin-left: auto;
`;

export const StyledEmptyForm = styled("div")`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 24px;
`;
